module.exports = __webpack_public_path__ + "static/media/431112721_783442796559805_6252266389219927265_n.93888dfb.jpg";